// extracted by mini-css-extract-plugin
export var active = "_b5-7";
export var blink = "_b5-8";
export var dropDownSelector = "_b5-4";
export var dropDownWrapper = "_b5-3";
export var fakeCursor = "_b5-6";
export var fontSizeButton = "_b5-9";
export var formQuillEditor = "_b5-0";
export var pressed = "_b5-a";
export var qlBlank = "_b5-1";
export var textFormattingToolbar = "_b5-2";
export var textToolbarOption = "_b5-5";